module.exports = __webpack_public_path__ + "img/WSW.1f15acfb.svg";